import React from "react";

import { Grid, Section, Select } from "@samskip/frontend-components";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { BookingTemplateConstants } from "@assets/constants";
import { BookingTemplateFormTypes } from "@assets/formTypes";
import { useAppSelector } from "@assets/hooks/redux";
import {
  countryLabelMapper,
  countryValueMapper,
} from "@assets/utilities/labelMapperUtils";
import { WithFormController } from "@components";
import { countriesState } from "@state/slices/registrySlice";

type BillOfLadingSection = {
  control: Control<BookingTemplateFormTypes.CargoForm>;
};

const BillOfLadingSection = ({ control }: BillOfLadingSection) => {
  const { t } = useTranslation();
  const allCountries = useAppSelector(countriesState);

  return (
    <Section title={t("LABEL_BILL_OF_LADING")}>
      <Grid mdCol={3}>
        <WithFormController control={control} name="BillOfLadingType">
          <Select
            fullWidth
            getOptionLabel={(billOption) => t(billOption.label)}
            id="bill-of-lading"
            isClearable
            label={t("LABEL_BILL_OF_LADING_TYPE")}
            options={BookingTemplateConstants.BILLS}
            placeholder={t("PLACEHOLDER_SELECT_BILL_OF_LADING")}
            portaling
          />
        </WithFormController>
        <WithFormController control={control} name="CountryOfOrigin">
          <Select
            fullWidth
            getOptionLabel={countryLabelMapper}
            getOptionValue={countryValueMapper}
            id="country-of-origin"
            isClearable
            label={t("LABEL_COUNTRY_OF_ORIGIN")}
            options={allCountries}
            placeholder={t("PLACEHOLDER_SELECT_COUNTRY_OF_ORIGIN")}
            portaling
          />
        </WithFormController>
      </Grid>
    </Section>
  );
};

export default BillOfLadingSection;
